export const basePath = 'api/users'

interface AccessRecord {
  to: number;
  privilege_type_id: number;
}

export interface Item {
  user_id: number;
  username: string;
  email: string;
  first_name: string;
  image: string;
  last_name: string;
  home_group: number;
  languages_preferred: string;
  group_memberships: {
    group_id: number;
    group: {
      group_name: string;
      yahoo_group_name: string;
      group_status_id: number;
      region: {
        region_id: number;
        region_name: string;
        country: {
          country_id: number;
          country_name: string;
        };
      };
    };
  };
  user_info: {
    signup_date: string;
    reputation: number;
  };
  accesses?: AccessRecord[]
}

export interface ModuleState {
  items: Item[];
  item: Item;
}
